import { ApiErrorDTO } from "@bvhi/backend-api";
import { createContext, Dispatch, SetStateAction } from "react";

export interface IApiErrorContext {
  setErrors: Dispatch<SetStateAction<ApiErrorDTO | undefined>>;
}

const defaultState: IApiErrorContext = {
  setErrors: () => console.warn("ApiErrorContext: Not in scope"),
};

export const ApiErrorContext = createContext<IApiErrorContext>(defaultState);
